// prettier-ignore
window.MutationObserver=window.MutationObserver||function(w){function v(a){this.i=[];this.m=a}function I(a){(function c(){var d=a.takeRecords();d.length&&a.m(d,a);a.h=setTimeout(c,v._period)})()}function p(a){var b={type:null,target:null,addedNodes:[],removedNodes:[],previousSibling:null,nextSibling:null,attributeName:null,attributeNamespace:null,oldValue:null},c;for(c in a)b[c]!==w&&a[c]!==w&&(b[c]=a[c]);return b}function J(a,b){var c=C(a,b);return function(d){var f=d.length,n;b.a&&3===a.nodeType&&a.nodeValue!==c.a&&d.push(new p({type:"characterData",target:a,oldValue:c.a}));b.b&&c.b&&A(d,a,c.b,b.f);if(b.c||b.g)n=K(d,a,c,b);if(n||d.length!==f)c=C(a,b)}}function L(a,b){return b.value}function M(a,b){return"style"!==b.name?b.value:a.style.cssText}function A(a,b,c,d){for(var f={},n=b.attributes,k,g,x=n.length;x--;)k=n[x],g=k.name,d&&d[g]===w||(D(b,k)!==c[g]&&a.push(p({type:"attributes",target:b,attributeName:g,oldValue:c[g],attributeNamespace:k.namespaceURI})),f[g]=!0);for(g in c)f[g]||a.push(p({target:b,type:"attributes",attributeName:g,oldValue:c[g]}))}function K(a,b,c,d){function f(b,c,f,k,y){var g=b.length-1;y=-~((g-y)/2);for(var h,l,e;e=b.pop();)h=f[e.j],l=k[e.l],d.c&&y&&Math.abs(e.j-e.l)>=g&&(a.push(p({type:"childList",target:c,addedNodes:[h],removedNodes:[h],nextSibling:h.nextSibling,previousSibling:h.previousSibling})),y--),d.b&&l.b&&A(a,h,l.b,d.f),d.a&&3===h.nodeType&&h.nodeValue!==l.a&&a.push(p({type:"characterData",target:h,oldValue:l.a})),d.g&&n(h,l)}function n(b,c){for(var g=b.childNodes,q=c.c,x=g.length,v=q?q.length:0,h,l,e,m,t,z=0,u=0,r=0;u<x||r<v;)m=g[u],t=(e=q[r])&&e.node,m===t?(d.b&&e.b&&A(a,m,e.b,d.f),d.a&&e.a!==w&&m.nodeValue!==e.a&&a.push(p({type:"characterData",target:m,oldValue:e.a})),l&&f(l,b,g,q,z),d.g&&(m.childNodes.length||e.c&&e.c.length)&&n(m,e),u++,r++):(k=!0,h||(h={},l=[]),m&&(h[e=E(m)]||(h[e]=!0,-1===(e=F(q,m,r,"node"))?d.c&&(a.push(p({type:"childList",target:b,addedNodes:[m],nextSibling:m.nextSibling,previousSibling:m.previousSibling})),z++):l.push({j:u,l:e})),u++),t&&t!==g[u]&&(h[e=E(t)]||(h[e]=!0,-1===(e=F(g,t,u))?d.c&&(a.push(p({type:"childList",target:c.node,removedNodes:[t],nextSibling:q[r+1],previousSibling:q[r-1]})),z--):l.push({j:e,l:r})),r++));l&&f(l,b,g,q,z)}var k;n(b,c);return k}function C(a,b){var c=!0;return function f(a){var k={node:a};!b.a||3!==a.nodeType&&8!==a.nodeType?(b.b&&c&&1===a.nodeType&&(k.b=G(a.attributes,function(c,f){if(!b.f||b.f[f.name])c[f.name]=D(a,f);return c})),c&&(b.c||b.a||b.b&&b.g)&&(k.c=N(a.childNodes,f)),c=b.g):k.a=a.nodeValue;return k}(a)}function E(a){try{return a.id||(a.mo_id=a.mo_id||H++)}catch(b){try{return a.nodeValue}catch(c){return H++}}}function N(a,b){for(var c=[],d=0;d<a.length;d++)c[d]=b(a[d],d,a);return c}function G(a,b){for(var c={},d=0;d<a.length;d++)c=b(c,a[d],d,a);return c}function F(a,b,c,d){for(;c<a.length;c++)if((d?a[c][d]:a[c])===b)return c;return-1}v._period=30;v.prototype={observe:function(a,b){for(var c={b:!!(b.attributes||b.attributeFilter||b.attributeOldValue),c:!!b.childList,g:!!b.subtree,a:!(!b.characterData&&!b.characterDataOldValue)},d=this.i,f=0;f<d.length;f++)d[f].s===a&&d.splice(f,1);b.attributeFilter&&(c.f=G(b.attributeFilter,function(a,b){a[b]=!0;return a}));d.push({s:a,o:J(a,c)});this.h||I(this)},takeRecords:function(){for(var a=[],b=this.i,c=0;c<b.length;c++)b[c].o(a);return a},disconnect:function(){this.i=[];clearTimeout(this.h);this.h=null}};var B=document.createElement("i");B.style.top=0;var D=(B="null"!=B.attributes.style.value)?L:M,H=1;return v}(void 0);
// prettier-ignore
Array.prototype.forEach || (Array.prototype.forEach = function (t, o) { if ('function' != typeof t) throw new TypeError(t + ' is not a function'); o = o || this; for (var r = 0, i = this.length; r !== i; ++r) t.call(o, this[r], r, this); });
// prettier-ignore
!function(){"use strict";if("object"==typeof window)if("IntersectionObserver"in window&&"IntersectionObserverEntry"in window&&"intersectionRatio"in window.IntersectionObserverEntry.prototype)"isIntersecting"in window.IntersectionObserverEntry.prototype||Object.defineProperty(window.IntersectionObserverEntry.prototype,"isIntersecting",{get:function(){return this.intersectionRatio>0}});else{var t=window.document,e=[];o.prototype.THROTTLE_TIMEOUT=100,o.prototype.POLL_INTERVAL=null,o.prototype.USE_MUTATION_OBSERVER=!0,o.prototype.observe=function(t){if(!this._observationTargets.some(function(e){return e.element==t})){if(!t||1!=t.nodeType)throw new Error("target must be an Element");this._registerInstance(),this._observationTargets.push({element:t,entry:null}),this._monitorIntersections(),this._checkForIntersections()}},o.prototype.unobserve=function(t){this._observationTargets=this._observationTargets.filter(function(e){return e.element!=t}),this._observationTargets.length||(this._unmonitorIntersections(),this._unregisterInstance())},o.prototype.disconnect=function(){this._observationTargets=[],this._unmonitorIntersections(),this._unregisterInstance()},o.prototype.takeRecords=function(){var t=this._queuedEntries.slice();return this._queuedEntries=[],t},o.prototype._initThresholds=function(t){var e=t||[0];return Array.isArray(e)||(e=[e]),e.sort().filter(function(t,e,n){if("number"!=typeof t||isNaN(t)||t<0||t>1)throw new Error("threshold must be a number between 0 and 1 inclusively");return t!==n[e-1]})},o.prototype._parseRootMargin=function(t){var e=(t||"0px").split(/\s+/).map(function(t){var e=/^(-?\d*\.?\d+)(px|%)$/.exec(t);if(!e)throw new Error("rootMargin must be specified in pixels or percent");return{value:parseFloat(e[1]),unit:e[2]}});return e[1]=e[1]||e[0],e[2]=e[2]||e[0],e[3]=e[3]||e[1],e},o.prototype._monitorIntersections=function(){this._monitoringIntersections||(this._monitoringIntersections=!0,this.POLL_INTERVAL?this._monitoringInterval=setInterval(this._checkForIntersections,this.POLL_INTERVAL):(i(window,"resize",this._checkForIntersections,!0),i(t,"scroll",this._checkForIntersections,!0),this.USE_MUTATION_OBSERVER&&"MutationObserver"in window&&(this._domObserver=new MutationObserver(this._checkForIntersections),this._domObserver.observe(t,{attributes:!0,childList:!0,characterData:!0,subtree:!0}))))},o.prototype._unmonitorIntersections=function(){this._monitoringIntersections&&(this._monitoringIntersections=!1,clearInterval(this._monitoringInterval),this._monitoringInterval=null,r(window,"resize",this._checkForIntersections,!0),r(t,"scroll",this._checkForIntersections,!0),this._domObserver&&(this._domObserver.disconnect(),this._domObserver=null))},o.prototype._checkForIntersections=function(){var t=this._rootIsInDom(),e=t?this._getRootRect():{top:0,bottom:0,left:0,right:0,width:0,height:0};this._observationTargets.forEach(function(o){var i=o.element,r=s(i),h=this._rootContainsTarget(i),c=o.entry,a=t&&h&&this._computeTargetAndRootIntersection(i,e),u=o.entry=new n({time:window.performance&&performance.now&&performance.now(),target:i,boundingClientRect:r,rootBounds:e,intersectionRect:a});c?t&&h?this._hasCrossedThreshold(c,u)&&this._queuedEntries.push(u):c&&c.isIntersecting&&this._queuedEntries.push(u):this._queuedEntries.push(u)},this),this._queuedEntries.length&&this._callback(this.takeRecords(),this)},o.prototype._computeTargetAndRootIntersection=function(e,n){if("none"!=window.getComputedStyle(e).display){for(var o,i,r,h,a,u,d,l,p=s(e),f=c(e),g=!1;!g;){var _=null,v=1==f.nodeType?window.getComputedStyle(f):{};if("none"==v.display)return;if(f==this.root||f==t?(g=!0,_=n):f!=t.body&&f!=t.documentElement&&"visible"!=v.overflow&&(_=s(f)),_&&(o=_,i=p,r=void 0,h=void 0,a=void 0,u=void 0,d=void 0,l=void 0,r=Math.max(o.top,i.top),h=Math.min(o.bottom,i.bottom),a=Math.max(o.left,i.left),u=Math.min(o.right,i.right),l=h-r,!(p=(d=u-a)>=0&&l>=0&&{top:r,bottom:h,left:a,right:u,width:d,height:l})))break;f=c(f)}return p}},o.prototype._getRootRect=function(){var e;if(this.root)e=s(this.root);else{var n=t.documentElement,o=t.body;e={top:0,left:0,right:n.clientWidth||o.clientWidth,width:n.clientWidth||o.clientWidth,bottom:n.clientHeight||o.clientHeight,height:n.clientHeight||o.clientHeight}}return this._expandRectByRootMargin(e)},o.prototype._expandRectByRootMargin=function(t){var e=this._rootMarginValues.map(function(e,n){return"px"==e.unit?e.value:e.value*(n%2?t.width:t.height)/100}),n={top:t.top-e[0],right:t.right+e[1],bottom:t.bottom+e[2],left:t.left-e[3]};return n.width=n.right-n.left,n.height=n.bottom-n.top,n},o.prototype._hasCrossedThreshold=function(t,e){var n=t&&t.isIntersecting?t.intersectionRatio||0:-1,o=e.isIntersecting?e.intersectionRatio||0:-1;if(n!==o)for(var i=0;i<this.thresholds.length;i++){var r=this.thresholds[i];if(r==n||r==o||r<n!=r<o)return!0}},o.prototype._rootIsInDom=function(){return!this.root||h(t,this.root)},o.prototype._rootContainsTarget=function(e){return h(this.root||t,e)},o.prototype._registerInstance=function(){e.indexOf(this)<0&&e.push(this)},o.prototype._unregisterInstance=function(){var t=e.indexOf(this);-1!=t&&e.splice(t,1)},window.IntersectionObserver=o,window.IntersectionObserverEntry=n}function n(t){this.time=t.time,this.target=t.target,this.rootBounds=t.rootBounds,this.boundingClientRect=t.boundingClientRect,this.intersectionRect=t.intersectionRect||{top:0,bottom:0,left:0,right:0,width:0,height:0},this.isIntersecting=!!t.intersectionRect;var e=this.boundingClientRect,n=e.width*e.height,o=this.intersectionRect,i=o.width*o.height;this.intersectionRatio=n?Number((i/n).toFixed(4)):this.isIntersecting?1:0}function o(t,e){var n,o,i,r=e||{};if("function"!=typeof t)throw new Error("callback must be a function");if(r.root&&1!=r.root.nodeType)throw new Error("root must be an Element");this._checkForIntersections=(n=this._checkForIntersections.bind(this),o=this.THROTTLE_TIMEOUT,i=null,function(){i||(i=setTimeout(function(){n(),i=null},o))}),this._callback=t,this._observationTargets=[],this._queuedEntries=[],this._rootMarginValues=this._parseRootMargin(r.rootMargin),this.thresholds=this._initThresholds(r.threshold),this.root=r.root||null,this.rootMargin=this._rootMarginValues.map(function(t){return t.value+t.unit}).join(" ")}function i(t,e,n,o){"function"==typeof t.addEventListener?t.addEventListener(e,n,o||!1):"function"==typeof t.attachEvent&&t.attachEvent("on"+e,n)}function r(t,e,n,o){"function"==typeof t.removeEventListener?t.removeEventListener(e,n,o||!1):"function"==typeof t.detatchEvent&&t.detatchEvent("on"+e,n)}function s(t){var e;try{e=t.getBoundingClientRect()}catch(t){}return e?(e.width&&e.height||(e={top:e.top,right:e.right,bottom:e.bottom,left:e.left,width:e.right-e.left,height:e.bottom-e.top}),e):{top:0,bottom:0,left:0,right:0,width:0,height:0}}function h(t,e){for(var n=e;n;){if(n==t)return!0;n=c(n)}return!1}function c(t){var e=t.parentNode;return e&&11==e.nodeType&&e.host?e.host:e&&e.assignedSlot?e.assignedSlot.parentNode:e}}();

var adhome = adhome || {};
adhome.util = $.extend(
  {
    hasElement(el) {
      return $(el).length > 0;
    },
    scrollToTop(nTime) {
      $('html, body').animate(
        {
          scrollTop: 0
        },
        nTime
      );
    }
  },
  adhome.util || {}
);

adhome.View = adhome.View || {};
adhome.View.common = adhome.View.common || {};

adhome.View.navigation = function () {
  this.init();
};
adhome.View.navigation.prototype = {
  _bMouseOver: false,
  init() {
    this._assignElements();
    this._attachEventHandlers();
  },
  _assignElements() {
    this._welHeader = $('.adhome_header');
    this._welHeaderInner = this._welHeader.find('.adhome_header_inner');
    this._welGnbList = this._welHeader.find('.adhome_gnb_list');
    this._welGnbMenu = this._welGnbList.find('.adhome_menu');
  },
  _attachEventHandlers() {
    this._welGnbMenu.on('mouseenter', $.proxy(this._onMouseenterGnbMenu, this));
    this._welGnbMenu.on('mouseleave', $.proxy(this._onMouseleaveGnbMenu, this));

    this._welGnbMenu.on('click', '> a', $.proxy(this._onClickGnbMenuLink, this));
    this._welGnbList
      .next()
      .find('a, button')
      .eq(0)
      .on('focusin', $.proxy(this._onGnbNextFocus, this));

    this._welGnbList.menuAim({
      rowSelector: '.adhome_menu > a',
      enter: $.proxy(this._enterSubMenu, this),
      exitMenu: $.proxy(this._exitSubMenu, this)
    });
  },
  _onMouseenterGnbMenu(e) {
    var welTarget = $(e.currentTarget);
    this._bMouseOver = true;
    this._showSubMenu(welTarget);
  },
  _onMouseleaveGnbMenu() {
    this._bMouseOver = false;
    this._hideSubMenu(this._getCurrentMenu());
  },
  _onGnbNextFocus() {
    this._bMouseOver = false;
    this._hideSubMenu(this._getCurrentMenu());
  },
  _onClickGnbMenuLink(e) {
    e.preventDefault();

    var welTarget = $(e.currentTarget);
    var welTargetList = welTarget.parent();

    if (this._bMouseOver) {
      return;
    }

    if (welTargetList.hasClass('on')) {
      this._hideSubMenu(welTargetList);
    } else {
      this._showSubMenu(welTargetList);
    }
  },
  _enterSubMenu(elem) {
    var welTarget = $(elem).parent();
    this._bMouseOver = true;
    this._showSubMenu(welTarget);
  },
  _exitSubMenu() {
    return true;
  },
  _showSubMenu(welCurrentMenu) {
    welCurrentMenu.addClass('on').siblings().removeClass('on');
    welCurrentMenu.find('> a').attr('aria-expanded', 'true');
    welCurrentMenu.find('.adhome_submenu > a').attr('tabindex', '0');
    welCurrentMenu.siblings().find('.adhome_menu > a').attr('aria-expanded', 'false');
    welCurrentMenu.siblings().find('.adhome_submenu > a').attr('tabindex', '-1');
    welCurrentMenu.on('keydown.a11y', $.proxy(this._onKeydownA11y, this));

    if (!welCurrentMenu.find('.adhome_submenu_list').attr('style')) {
      var welCurrentMenuLink = welCurrentMenu.find('> a');
      var nPaddingLeft =
        welCurrentMenuLink.offset().left -
        this._welHeaderInner.offset().left +
        welCurrentMenuLink.innerWidth() / 2 -
        welCurrentMenu.find('.adhome_submenu > a').innerWidth() / 2;
      welCurrentMenu.find('.adhome_submenu_list').css('padding-left', nPaddingLeft);
    }
  },
  _hideSubMenu(welCurrentMenu) {
    welCurrentMenu.removeClass('on');
    welCurrentMenu.find('> a').attr('aria-expanded', 'false');
    welCurrentMenu.find('.adhome_submenu > a').attr('tabindex', '-1');
    welCurrentMenu.off('keydown.a11y');
  },
  _onKeydownA11y(e) {
    var sKeyCode = e.sKeyCode || e.which;
    var bTabKey = sKeyCode === 9;
    var bEscKey = sKeyCode === 27;
    var welCurrentMenu = null;
    if (bEscKey) {
      welCurrentMenu = this._getCurrentMenu();
      if (welCurrentMenu.length) {
        this._hideSubMenu(welCurrentMenu);
        welCurrentMenu.find('> a').focus();
      }
      // else {
      //   this._hideTotalCtgLayer();
      //   this._welCtgAllOpen.focus();
      // }
    }
    if (bTabKey) {
      this._bMouseOver = false;
    }
  },
  _getCurrentMenu() {
    return this._welGnbMenu.filter('.on');
  }
};

$(function () {
  // TAB
  $('.adhome_tab').tabs({
    sActiveClass: 'on',
    elTabBtn: '.adhome_tab_list>li',
    elTabPanel: '.adhome_tab_panel',
    elFilter: '.adhome_tab_btn',
    fnChange: function (welPanel) {
      if ($(this).is('[role="tab"]')) {
        // 방어코딩 - role tab 속성이 있을때만 동작
        $(this)
          .attr('aria-selected', 'true')
          .parent()
          .siblings()
          .children()
          .attr('aria-selected', 'false');
        welPanel.addClass('on').siblings().removeClass('on');
      }
    }
  });
  $('.adhome_sub_tab').tabs({
    sActiveClass: 'on',
    elTabBtn: '.adhome_sub_tablist>li',
    elTabPanel: '.adhome_sub_tabpanel',
    elFilter: '.adhome_sub_tabbtn',
    fnChange: function (welPanel) {
      if ($(this).is('[role="tab"]')) {
        // 방어코딩 - role tab 속성이 있을때만 동작
        $(this)
          .attr('aria-selected', 'true')
          .parent()
          .siblings()
          .children()
          .attr('aria-selected', 'false');
        welPanel.addClass('on').siblings().removeClass('on');
      }
    }
  });

  // 카테고리
  if (adhome.util.hasElement('.adhome_gnb_list')) {
    var oAdhomeViewNavigation = new adhome.View.navigation();
  }

  // TOP 버튼
  const floatingTopBtn = document.querySelector('#floating .adhome_btn_top');
  function _toFitScroll(cb, { dismissCondition = () => false, triggerCondition = () => true }) {
    if (!cb) {
      throw Error('Invalid required arguments');
    }
    let tick = false;
    return function () {
      if (tick) {
        return;
      }
      tick = true;
      return requestAnimationFrame(() => {
        if (dismissCondition()) {
          tick = false;
          return;
        }
        if (triggerCondition()) {
          //console.log('real call')
          tick = false;
          return cb();
        }
      });
    };
  }
  window.addEventListener(
    'scroll',
    _toFitScroll(
      function () {
        if (window.pageYOffset > 0) {
          floatingTopBtn.classList.add('is_visible');
        } else {
          floatingTopBtn.classList.remove('is_visible');
        }
      },
      {
        // triggerCondition:
        // dismissCondition:
      }
    ),
    { passive: true }
  );
  floatingTopBtn.addEventListener('click', function (e) {
    e.preventDefault();
    adhome.util.scrollToTop(400);
  });
});
